import React from "react";
import { Hero, PageContent } from "../../components";

// TODO: Ne pas oublier les unitées + les titres :) (des %)
function Entrepreneurship() {
  return (
    <div className="flex overflow-x-hidden overflow-y-hidden relative flex-col z-8">
      <Hero title="Entrepreneurship">
        Engineering is seeing obstacles as puzzles {" "}
        <span className="text-lg font-black text-RougePastel md:text-xl lg:text-2xl">
          to be solved.
        </span>{" "}
      </Hero>

      <PageContent>
        {`

Realizing we could spread our enthusiasm of synthetic biology to our
local community, our team focused on raising awareness about global
challenges like water sanitation and climate change. Interacting with
diverse stakeholders, we highlighted the importance of greener heating
solutions and the risks of endocrine disruptors. Additionally, we
showcased the potential of synthetic biology in tackling these issues
and passionately shared our scientific enthusiasm, especially with
children.

## Introduction
The very essence of the Clean Heat project is to respond to urgent societal and environmental
issues. Its proper implementation is dependent on several entrepreneurial factors, which the
Ionis-Paris 2023 team attempted to satisfy by carrying out a survey of more than 279 people,
several participation in professional and general public conferences, market and regulatory
studies, fundraisings, and by surrounding itself with property experts. intellectual and business
partners.
## Our objectives and responses : 
- ### Develop a project that stands out as an innovative and easily accessible response to real environmental and social issues
  - #### Building a diverse and multidisciplinary team of young engineers ready to change the world !
    
    The story of Clean Heat was born with the desire to innovate to respond to
    everyday environmental and social issues, which many of us may face.
    
    To do so, a diverse and multidisciplinary team was created within the French
    group of engineering schools IONIS. It brings together 13 students from all
    social and professional backgrounds, working in the fields of biotechnology but
    also electronics, robotics and IT, and most of all, ready to change the world
    through synthetic biology ! 

      <div class="image_frame">
        <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/entrepreneurship/photo-groupe.jpeg">
      </div>

      Each member of the team represents a particular view of the world; diversity
and parity are therefore important to best represent society, its issues and its
resources. In addition, the supervisors of the Ionis-Paris 2023 team have a 
different experience and contribute to bringing a richer perspective to the
project.

  - #### Gathering knowledge and understanding the main challenges before and after the project brainstorming
    
    Since the objective of Clean Heat is to respond to real needs, research was
    carried out by team members before the first brainstorming of the project. Thus,
    mainly through consultation of the news but also thanks to the strong
    environmental context governing the activities of the Ionis-Paris schools group,
    the subjects of micropollutants and the energy crisis have reached the heart of
    our concerns.
    
    To confirm the potential of the Clean Heat project, a survey was distributed
    among the French population to assess the main issues and possible
    responses. Among the 279 answers, 203 said that the first inconvenient of their
    heating was either the cost or the environmental impact. Moreover, aournd 70%
    of the respondents declared they wouldn’t be affraid by the fact Clean Heat is
    using GMOs and would agree to use our system as urban heating.

    The survey conclusions were reinforced during our participation in various
    festivals and general public conferences, then through a market study. 

    In 2022, the average price of a MWh of electricity in industry rose by 45% 
    compared with 2021, and that of a MWh of gas by 107% [1]. In 2021, the 
    energy bill amounted to 17.1 billion current euros , up 46% on 2020 as a
    result of higher energy prices. We can therefore deduce an increase in 
    demand over the years, as well as a need for lower prices. The cost of our
    system depends on three main expenses: installation, maintenance and
    electricity consumption. Due to the early stage of our innovation, we were 
    only able to calculate its electricity consumption : we have concluded that if
    our system heats for 10 dwellings, the electrical consumption will be smaller
    compared to heating from an electrical source ([Link to Implementation](https://2023.igem.wiki/ionis-paris/project/implementation)). 
    Finally, we assessed our project throughout a SWOT analysis :
    
    <div class="image_frame">
        <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/entrepreneurship/swot.jpg">
    </div>

    Interviews with other stakeholders (researchers, producers of heating
    solutions, companies in water pollution control, ecological departments of
    cities, etc.) were carried out in parallel with the survey of the general public in
    order to better understand the real issues and limits of our project and include
    those elements in the R&D process
    
    <div class="image_frame horizontal">
        <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/entrepreneurship/double-science.jpeg">
        <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/entrepreneurship/forum-eau.jpg">
    </div>
    
  - #### Building a responsible business model
  
    To strengthen Clean Heat's competitiveness compared to conventional heating
    and water pollution control solutions, the team has built a business model
    based on environmental responsibility. The installation and regular
    maintenance of the Clean Heat system will in fact be financed by the recovery
    of urine into agricultural fertilizer and the biomass present in the
    photobioreactor into biofuels. This approach has been studied and validated by
    various stakeholders in the recovery of these wastes.
    
- ### Bringing the innovation to life in accordance with our environmental and societal values : fundraising, research and prototype
  - #### Collection of materials and funds to enable research for the Clean Heat proof of concept
   
    Research and development leading to the Clean Heat proof of concept requires significant funds.
    
    To carry out this project, the Ionis-Paris 2023 team had the opportunity to
    participate in a professional meeting Forum Labo where business partners
    were met such as Dutscher, Beckman Coulter or New England Biolabs.
    Exchanges of equipment as well as advice have thus been concluded within
    the framework of partnerships and sponsorships.
    
    <div class="image_frame horizontal">
        <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/entrepreneurship/forum-labo-2.jpg">
        <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/entrepreneurship/forum-labo-1.jpg">
    </div>

    At the same time, Clean Heat was highlighted at numerous professional events
    on the subjects of water, biotechnology or more generally science. These
    numerous interventions by the team made it possible to carry out fundraising
    with three main entities: the DIM BioConvS, the city of Villejuif, and the
    engineering schools SupBiotech, ESME and EPITA of the IONIS group.
    Crowdfunding was also launched to allow the population to support an
    innovative project with high societal and environmental value
    
  - #### Development of the Clean Heat simulation and prototype to go further
  
    Thanks to its multidisciplinary skills, the Ionis-Paris 2023 team developed an
    in-silico simulation to extrapolate its results obtained at the wet lab. This allows
    us to better understand and anticipate the profitability of Clean Heat at different
    scales. At the same time, a prototype of the photobioreactor was developed in
    partnership with our partner Synoxis Algae in order to begin transposing the
    results obtained in the wet lab in a concrete manner on a larger scale.
    
    <div class="image_frame">
        <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/entrepreneurship/sans-cache.jpeg">
    </div>

    In order to protect Clean Heat, intellectual protection steps were taken via initial
    meetings with expert firms (INPI). A SOLEAU envelope, which is a protection
    system on a French scale, is also being drafted.
    
  - #### Calculation of the carbon footprint for the coherence of the Clean Heat project
    
    Since the very essence of the project is to reduce the negative impact of water
    pollution and the energy used for heating, the team wants the final system to
    have the lowest possible carbon footprint.
    
    ## Sources :
    1. INSEE, 08/06/2023. En 2022, le prix annuel moyen du MWh d’électricité a augmenté de 45 % et celui du MWh de gaz de 107 %. INSEE, URL [https://www.insee.fr/fr/statistiques/7631039#:~:text=Insee%20Première%20·%20Juin%202023%20·%20n,MWh%20de%20gaz%20de%20107%
    20%25&text=En%202022%2C%20le%20prix%20moyen,MWh%20de%20gaz%20de%20107%20%25]

`}
      </PageContent>
    </div>
  );
}

export default Entrepreneurship;
